import React, { Component } from 'react';

import { Container, Row, Col } from 'reactstrap';
import LabelInput from '@components/LabelInput/LabelInput';
import LabelDropdown from '@components/LabelDropdown/LabelDropdown';

import CSS from './SubscribeForm.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class SubscribeForm extends Component {
  state = {
    formData: {
      Email: '',
      FirstName: '',
      LastName: '',
      Company: 'JetSuite',
      City: '',
      State: 'Alabama',
      PostalCode: '',
      leadPartitionIDCustom: 'JS'
    },
    status: 0
  };

  updateForm = (event, name) => {
    const currentData = { ...this.state.formData };

    currentData[name] = event.target.value;

    this.setState({
      formData: { ...currentData }
    });
  };

  submitHandler = () => {
    let myForm = window.marketo.getForm(1003);
    myForm.addHiddenFields({ ...this.state.formData });
    myForm.submit();
  };

  componentDidMount = () => {
    window.addEventListener('marketo-submitted-1003', () =>
      this.submitingHandler(2)
    );
    window.addEventListener('marketo-submitting-1003', () =>
      this.submitingHandler(1)
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener('marketo-submitted-1003', () =>
      this.submitingHandler(2)
    );
    window.removeEventListener('marketo-submitting-1003', () =>
      this.submitingHandler(1)
    );
  };

  submitingHandler = status => {
    this.setState({
      status: status
    });

    if (status === 2) {
      setTimeout(
        () =>
          this.setState({
            formData: {
              Email: '',
              FirstName: '',
              LastName: '',
              Company: 'JetSuite',
              City: '',
              State: 'Alabama',
              PostalCode: '',
              leadPartitionIDCustom: 'JS'
            },
            status: 0
          }),
        2000
      );
    }
  };

  render() {
    let heightStyle = {
      height: this.props.screenHeight + 'px'
    };

    let className = '';
    if (this.props.pageWidth < 992) {
      className = '';
    } else {
      className = 'abs-container';
    }
    return (
      <div style={heightStyle} id={this.props.id}>
        <Container fluid={true} className={className}>
          <Row className={CSS.wrapper + ' justify-content-center h-100'}>
            <Col
              md={9}
              sm={12}
              className={
                CSS['form-container'] +
                ' align-self-center h-60 background-white'
              }
            >
              <Container fluid={true} className={CSS.scrollable}>
                {this.state.status === 1 && (
                  <div className={CSS.loader}>
                    <FontAwesomeIcon icon={['far', 'spinner']} spin />
                    Submitting ...
                  </div>
                )}
                {this.state.status === 2 && (
                  <div className={CSS.loader}>
                    <FontAwesomeIcon icon={['far', 'check-circle']} />
                    Submited!
                  </div>
                )}

                <h1 className={CSS.header}>
                  Sign Up for JetSuite <div className={'d-md-none'} />
                  News & Updates
                </h1>

                <Row>
                  <Col md={5} className={'pb-4'}>
                    <LabelInput
                      label={'First Name'}
                      type={'text'}
                      name={'first_name'}
                      onChange={event => this.updateForm(event, 'FirstName')}
                      value={this.state.formData['FirstName']}
                    />
                  </Col>
                  <Col md={7} className={'pb-4'}>
                    <LabelInput
                      label={'Last Name'}
                      type={'text'}
                      name={'last_name'}
                      onChange={event => this.updateForm(event, 'LastName')}
                      value={this.state.formData['LastName']}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={5} className={'pb-4'}>
                    <LabelInput
                      label={'City'}
                      type={'text'}
                      name={'city'}
                      onChange={event => this.updateForm(event, 'City')}
                      value={this.state.formData['City']}
                    />
                  </Col>
                  <Col md={7} className={'pb-4'}>
                    <LabelInput
                      label={'Email'}
                      type={'email'}
                      name={'email'}
                      onChange={event => this.updateForm(event, 'Email')}
                      value={this.state.formData['Email']}
                    />
                  </Col>
                </Row>

                <Row className={'pb-4'}>
                  <Col md={5} xs={6}>
                    <Row>
                      <Col>
                        <LabelDropdown
                          placeholder={'State'}
                          type={'state'}
                          name={'state'}
                          onChange={event => this.updateForm(event, 'State')}
                          value={this.state.formData['State']}
                          options={[
                            'Alabama',
                            'Alaska',
                            'American Samoa',
                            'Arizona',
                            'Arkansas',
                            'California',
                            'Colorado',
                            'Connecticut',
                            'Delaware',
                            'District of Columbia',
                            'Federated States of Micronesia',
                            'Florida',
                            'Georgia',
                            'Guam',
                            'Hawaii',
                            'Idaho',
                            'Illinois',
                            'Indiana',
                            'Iowa',
                            'Kansas',
                            'Kentucky',
                            'Louisiana',
                            'Maine',
                            'Marshall Islands',
                            'Maryland',
                            'Massachusetts',
                            'Michigan',
                            'Minnesota',
                            'Mississippi',
                            'Missouri',
                            'Montana',
                            'Nebraska',
                            'Nevada',
                            'New Hampshire',
                            'New Jersey',
                            'New Mexico',
                            'New York',
                            'North Carolina',
                            'North Dakota',
                            'Northern Mariana Islands',
                            'Ohio',
                            'Oklahoma',
                            'Oregon',
                            'Palau',
                            'Pennsylvania',
                            'Puerto Rico',
                            'Rhode Island',
                            'South Carolina',
                            'South Dakota',
                            'Tennessee',
                            'Texas',
                            'Utah',
                            'Vermont',
                            'Virgin Island',
                            'Virginia',
                            'Washington',
                            'West Virginia',
                            'Wisconsin',
                            'Wyoming'
                          ]}
                        />
                      </Col>
                      <Col className={'d-none d-md-block'}>
                        <button
                          type={'button'}
                          className={'btn btn-primary btn-block'}
                          onClick={this.submitHandler}
                        >
                          Submit
                        </button>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row>
                  <Col className={'d-block d-md-none mb-4'}>
                    <button
                      type={'button'}
                      className={'btn btn-default btn-block'}
                      onClick={this.submitHandler}
                    >
                      Submit
                    </button>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <p className={'font-sm asap-regular color-dark-grey'}>
                      *By subscribing to JetSuite News & Updates, you are
                      agreeing to receive emails from JetSuite Inc.
                    </p>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default SubscribeForm;



// WEBPACK FOOTER //
// ./src/components/Subscribe/SubscribeForm/SubscribeForm.jsx